import { Injectable } from '@angular/core';

/** A request to show the documents of a record (button of the record windows), consumed by the Documents window */
export interface DocumentsLaunch {
  tableId: number;
  recordId: number;
}

@Injectable({ providedIn: 'root' })
export class DocumentsLaunchService {
  #pending: { launch: DocumentsLaunch; at: number } | null = null;
  readonly #listeners = new Set<(l: DocumentsLaunch) => void>();

  /** open Documents windows apply it at once; a window opened in the next seconds takes it too */
  request(launch: DocumentsLaunch): void {
    this.#pending = { launch, at: Date.now() };
    this.#listeners.forEach((l) => l(launch));
  }

  take(): DocumentsLaunch | null {
    const p = this.#pending;
    this.#pending = null;
    return p && Date.now() - p.at < 5000 ? p.launch : null;
  }

  listen(listener: (l: DocumentsLaunch) => void): () => void {
    this.#listeners.add(listener);
    return () => this.#listeners.delete(listener);
  }
}
